import axios from "axios";
import useApplicationInfo from "hooks/useAppInfo";

import { useEffect, useState } from "react";
import { SET_ENV } from "store/actions/actionTypes/types";
import { useAppDispatch, useAppSelector } from "store/hooks";

// property keys are exported for use in DesktopPropertyFetcher.tsx

export const staticKeys = [
  "REACT_APP_PS_ENV",
  "REACT_APP_PS_CAD_API_KEY",
  "REACT_APP_PS_USD_API_KEY",
  "REACT_APP_PS_CAD_MERCHANT_ID",
  "REACT_APP_PS_USD_MERCHANT_ID",
  "REACT_APP_STRIPE_CAD_API_KEY",
  "REACT_APP_STRIPE_USD_API_KEY",
  "REACT_APP_API_KEY",
  "REACT_APP_API_KEY_FOR_OW",
  "REACT_APP_GOOGLE_PAY_ENV",
  "REACT_APP_GOOGLE_PAY_MERCHANT_ID",
  "REACT_APP_GOOGLE_CLIENT_ID",
  "REACT_APP_DISCORD_CLIENT_ID",
  "REACT_APP_DISCORD_REDIRECT_URI",
  "REACT_APP_FACEBOOK_APP_ID",
  "REACT_APP_MICROSOFT_APP_ID",
  "REACT_APP_MICROSOFT_REDIRECT_URI",
  "REACT_APP_ONE_SIGNAL_APP_ID",
  "REACT_APP_WEBAPP_URL",
];

export const nonStaticKeys = [
  "REACT_APP_STRIPE_IS_ENABLED",
  "REACT_APP_GOOGLE_PAY_IS_ENABLED",
  "REACT_APP_DELIVERY_FEE_WAIVER",
  "REACT_APP_DEBUG",
  "REACT_APP_DOUBLE_BUCKS_DATES",
  "REACT_APP_FULL_MAINTENANCE_MODE",
  "REACT_APP_STORE_MAINTENANCE_MODE",
  "REACT_APP_GAME_CHALLENGES_ENABLED",
  "REACT_APP_GAME_CHALLENGES_PRIVATE_MODE",
];

export const desktopNonStaticKeys = [
  "REACT_APP_STRIPE_IS_ENABLED",
  "REACT_APP_GOOGLE_PAY_IS_ENABLED",
  "REACT_APP_DELIVERY_FEE_WAIVER",
  "REACT_APP_DEBUG",
  "REACT_APP_DOUBLE_BUCKS_DATES",
  "REACT_APP_FULL_MAINTENANCE_MODE",
  "REACT_APP_STORE_MAINTENANCE_MODE",
  "REACT_APP_GAME_CHALLENGES_ENABLED",
  "REACT_APP_GAME_CHALLENGES_PRIVATE_MODE",
];

export const WebAppPropertyFetcher: React.FC = () => {
  const [envVariables, setEnvVariables] = useState<null | any[]>();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dispatch = useAppDispatch();
  const { application, applicationVersion } = useApplicationInfo();

  const env = useAppSelector((state) => state.auth.env);

  useEffect(() => {
    if (!!envVariables && !!application) {
      dispatch({ type: SET_ENV, payload: envVariables });
    }
  }, [dispatch, envVariables, application]);

  const url = `${BASE_URL}/api/config/waks`;
  useEffect(() => {
    const fetchProps = async (
      application: string,
      applicationVersion: string
    ) => {
      try {
        const request = {
          application,
          applicationVersion,
          propertyKeys: !env
            ? [...nonStaticKeys, ...staticKeys]
            : nonStaticKeys,
        };
        const response = await axios.post(url, request);

        if (response.status === 200) {
          const properties = response?.data?.propertiesValue;
          setEnvVariables(properties);
        }
      } catch (error: any) {
        console.log(error);
      }
    };

    if (!env && !!application && !!applicationVersion) {
      // Fetch property values initially
      fetchProps(application, applicationVersion);
    }
    const interval = setInterval(fetchProps, 15 * 60 * 1000);
    return () => clearInterval(interval);
  }, [env, application, applicationVersion, url, dispatch]);

  return null;
};

export default WebAppPropertyFetcher;
